import Image from 'next/image';
import type { ReactNode } from 'react';

/** 글 스토리 본문 — 블록을 어떤 순서로 놓을지는 부르는 쪽(StoryContent)이 정한다 */
export default function StoryArticle({ children }: { children: ReactNode }) {
  return (
    <div className="px-5 pb-[50px] lg:px-10 lg:pb-10">
      <hr className="border-3b-background-200" />
      <div className="mt-5 flex flex-col gap-5 text-3b-text-primary lg:mt-10 lg:gap-10">
        {children}
      </div>
    </div>
  );
}

export function StoryArticleSection({
  heading,
  children,
}: {
  heading: string;
  children: ReactNode;
}) {
  return (
    <section>
      <h3 className="whitespace-pre-line text-[20px] font-semibold leading-7 tracking-[-0.336px] lg:text-[24px] lg:leading-8 lg:tracking-[-0.464px]">
        {heading}
      </h3>
      <p className="mt-3 whitespace-pre-line text-[16px] font-medium leading-6 tracking-[-0.176px] lg:mt-4 lg:text-[18px] lg:leading-7 lg:tracking-[-0.256px]">
        {children}
      </p>
    </section>
  );
}

export function StoryArticleProfile({
  image,
  name,
  description,
}: {
  image: string;
  name: string;
  description: string;
}) {
  return (
    <figure className="flex flex-col items-center gap-2.5">
      <span className="relative block size-40 overflow-hidden rounded-full lg:size-[200px]">
        <Image
          src={image}
          alt=""
          fill
          sizes="(min-width: 990px) 200px, 160px"
          className="object-cover"
        />
      </span>
      <figcaption className="text-center text-[16px] font-medium leading-6 tracking-[-0.176px] lg:text-[18px] lg:leading-7 lg:tracking-[-0.256px]">
        <span className="block font-semibold">{name}</span>
        {description}
      </figcaption>
    </figure>
  );
}
